import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { config } from "@financial-advisory/config";
import { store } from "@financial-advisory/data-access/financial-advisory-api-service";
import "@unlikelyai-magic/ui/shadcn/assets/global.css";
import App from "./app/App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const render = async () => {
  root.render(
    <StrictMode>
      <Auth0Provider
        domain={config.AUTH0.DOMAIN}
        clientId={config.AUTH0.CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: config.AUTH0.AUDIENCE,
          scope: "email",
        }}
      >
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </Auth0Provider>
    </StrictMode>
  );
};

render();
